import LogKidPaymentForm from './LogKidPayment';
export default LogKidPaymentForm;
